import entity from '@/../region.json';

const acceptedLanguages = entity.supportedLanguages;
/**
 * @return {string}
 */
export function getUserLang() {
  const lang = navigator.language;
  const slicedLang = lang.slice(0, 2);
  return acceptedLanguages[slicedLang] || entity.defaultLang;
}

/** Used for styling. routePath -> '/de/register'
 * @return {string}
 */
export function getLangFromRoute(routePath) {
  // If the url is from an email the path will start with '/app/de | en | sv'
  // so it is necessary to check for this path.
  if (routePath.startsWith('/app/')) {
    const [, lang] = routePath.slice(1).split('/'); // avoid leading '/' slash
    return acceptedLanguages[lang] || 'en';
  }
  const lang = routePath.slice(1, 3); // '/de/register' -> 'de'
  return acceptedLanguages[lang] || entity.defaultLang;
}
